var map = {
	"./dependencies.js": "./src/selectors/project/dependencies.js",
	"./helper-metadata.js": "./src/selectors/project/helper-metadata.js",
	"./info.js": "./src/selectors/project/info.js",
	"./module-map.js": "./src/selectors/project/module-map.js",
	"./require-context.js": "./src/selectors/project/require-context.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;



//////////////////
// WEBPACK FOOTER
// ./src/selectors/project \.js$
// module id = 100
// module chunks = 0 1 2